var _defs, _metadata, _rect, _circle, _circle2, _path, _g, _path2, _g2, _line, _line2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1911 1546",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:43.6356}\r\n    .str1 {stroke:black;stroke-width:43.6356;stroke-linecap:round}\r\n    .str2 {stroke:black;stroke-width:43.6356;stroke-linecap:round;stroke-linejoin:bevel}\r\n    .fil0 {fill:none}\r\n    .fil1 {fill:#B67B70}\r\n    .fil3 {fill:#B87A71}\r\n    .fil2 {fill:#DCA885}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_750092480"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1911,
    height: 1546
  })), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    transform: "matrix(-0.328559 0.114005 -0.006306 0.351511 1303.01 386.323)",
    r: 272
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    transform: "matrix(0.315845 0.112349 0.00606197 0.346405 608.185 387.785)",
    r: 272
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M965 699c-147,0 -231,84 -249,100 -244,230 106,614 249,614 143,0 493,-384 248,-614 -17,-16 -102,-100 -248,-100z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M955 1132c0,31 2,63 0,94 -3,47 -105,53 -111,-30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M956 924c0,31 -2,271 0,302 3,47 105,53 111,-30"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "fil0 str2",
    x1: 715,
    y1: 722,
    x2: 592,
    y2: 662
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "fil0 str2",
    x1: 1209,
    y1: 722,
    x2: 1332,
    y2: 662
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fil0 str2",
    points: "1030,818 962,863 901,819 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni9);
export default __webpack_public_path__ + "static/media/ani9.6e2eb8165e3dee80d71d1e8000614aee.svg";
export { ForwardRef as ReactComponent };